import { WithdrawalAccountFormType } from 'modules/client/common/forms/withdrawalAccountForm';

export interface WithdrawalAccountItem extends WithdrawalAccountFormType {
  number: number;
  id: string;
  index: number;
}

export enum WithdrawalAccountOptionType {
  delete = 'delete',
}

export interface WithdrawalAccountColumnArgs {
  shownOptions?: Partial<Record<WithdrawalAccountOptionType, boolean>>;
  editable?: boolean;
  onClickOption: (
    item: WithdrawalAccountItem,
    option: WithdrawalAccountOptionType
  ) => void;
}
